import Vue from 'vue';
import {
  Icon,
  Iconfont,
  Button,
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Row,
  Col,
  Column,
  ColumnItem,
  Checkbox,
  CheckboxGroup,
  Confirm,
  Cascader,
  SlideVerify,
  Select,
  SelectOption,
  SelectOptionGroup,
  DatePicker,
  Tooltip,
  Popper,
  Empty,
  ConditionFilter,
  ConditionFilterItem,
  RadioGroup,
  Radio,
  Switch,

  Loading,
  Menu,
  MenuGroup,
  MenuItem,
  BreakpointDiv,

  Table,
  TableColumn,
  Pagination,
  Toast,
  Tips,
  Service,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Tabs,
  TabPanel,
  InputUrl
} from '@polyv/polyv-ui';

Vue.use(Tabs);
Vue.use(TabPanel);
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Row);
Vue.use(Col);
Vue.use(Icon);
Vue.use(Iconfont);
Vue.use(Checkbox);
Vue.use(SlideVerify);
Vue.use(Cascader);
Vue.use(Menu);
Vue.use(Column);
Vue.use(ColumnItem);
Vue.use(Confirm);
Vue.use(MenuGroup);
Vue.use(MenuItem);
Vue.use(BreakpointDiv);
Vue.use(Radio);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Select);
Vue.use(SelectOption);
Vue.use(SelectOptionGroup);
Vue.use(RadioGroup);
Vue.use(DatePicker);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Toast);
Vue.use(CheckboxGroup);
Vue.use(Dialog);
Vue.use(InputUrl);
Vue.use(Switch);

Vue.use(ConditionFilter);
Vue.use(ConditionFilterItem);
Vue.use(Loading);
Vue.use(Service, {
  serviceType: 'Zhichi',
});
Vue.use(Tips);
Vue.use(Tooltip);
Vue.use(Popper);
Vue.use(Empty);
